import React, { useState } from 'react';
import { FaGithub, FaClipboard, FaLinkedin, FaMedium } from 'react-icons/fa';
import mailSvg from '../images/svgs/mail.svg';
import mailSvg2 from '../images/svgs/mail2.svg';

const NewContact = () => {
  const [cardActive, setCardActive] = useState(false);
  const [buttonText, setButtonText] = useState('');

  const handleFlip = () => {
    setCardActive(!cardActive);
  };

  const copyToClipboard = () => {
    const copyText = document.querySelector('#contact-email').textContent;
    const textArea = document.createElement('textarea');
    textArea.value = copyText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    setButtonText('Copied!');
    setTimeout(() => {
      setButtonText('');
    }, 2000); 
  };

  const submitButton = () => {
    const emailInput = document.getElementById('email');
    const textArea = document.getElementById('text-area');
    const successMsg = document.getElementById('success-msg');
    if (emailInput.value !== '' && textArea.value !== '') {
      setTimeout(() => {
        emailInput.value = '';
        textArea.value = '';
        successMsg.innerHTML =
          'Thank you for your message, I will be in touch soon';
      }, 1000);
      setTimeout(() => {
        successMsg.innerHTML = '';
      }, 3000);
    }
  };

  return (
    <div id="contact-page">
      <div id="contact">Contact</div>
      <div id="contact-card" className={`${cardActive ? 'cardFlip' : ''}`}>
        <div id="outer-card">
          <div id="contact-name">Daniel Boyce</div>
          <div id="clip-flex">
            <div id="contact-email">danboyce92@yahoo.com</div>
            <button onClick={copyToClipboard} className="clipboard">
              <FaClipboard size={20} />
            </button>
          </div>
          <div id="copied">{buttonText}</div>
          <div id="icon-flex">
            <a href="https://github.com/danboyce92">
              <FaGithub className="contact-icon" />
            </a>

            <a href="https://www.linkedin.com/in/daniel-boyce-615065102/">
              <FaLinkedin className="contact-icon" />
            </a>
            <a href="https://medium.com/@danb92">
              <FaMedium className="contact-icon" />
            </a>
          </div>
          <div id="contact-text">I look forward to hearing from you.</div>
          <div onClick={handleFlip} id="contact-btn">
            Contact here
          </div>
          <img id="mail-svg" src={mailSvg} alt="mail" />
        </div>
        <div id="inner-card">
          <form
            action="https://formsubmit.co/daarf92@gmail.com"
            method="POST"
            id="msg-form"
          >
            <label id="email-lab">Email</label>
            <input
              required
              name="email"
              id="email"
              placeholder="Your email here.."
            />
            <label id="msg-lab">Message</label>
            <textarea
              required
              name="message"
              id="msg"
              placeholder="Your message here.."
            ></textarea>
            <button onClick={submitButton} id="send-btn">
              Send
            </button>
          </form>
          <div onClick={handleFlip} id="back-btn">
            Back
          </div>
          <img className="backwards" id="mail-svg" src={mailSvg2} alt="mail" />
        </div>
      </div>
    </div>
  );
};

export default NewContact;
